import React from 'react';
import { Icon } from './Icon.js';
export const IconGreaterThan = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M20.4678 11.1162L22.1377 12L20.4678 12.8838L4 21.6016V19.3389L17.8623 12L4 4.66016V2.39746L20.4678 11.1162Z", fill: "currentColor", "data-stroke": "none" })));
};
//# sourceMappingURL=IconGreaterThan.js.map